const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (email: string) =>
  EMAIL_PATTERN.test(email.trim()) && email.trim().length <= 254;
